$(function() {
	//クイックカート表示
	$(document).on('click touchstart', '.produce__form--btn--input input.submit', function (event) {
//		$('body').toggleClass('js-CartDrawer-open');
	});



	// 現在の選択状態からvariant keyを取得
	function getVariantKeyFromSelectedNow(){
		var key = "";
		for(i=0;i<productOptionCount;i++){
			var v = $('.selector-'+String(i)+":checked").val();
			if(i>0){
				v = " / " + v;
			}
			key = key + v;
		}
		return key;
	}

	function getVariantID(){
		var key = getVariantKeyFromSelectedNow();
		console.log(key);
		var variantId = $('#productSelect option[data-variant_title="' + key +  '"]').val();
		return variantId;
	}

	function setVariantID(){

	}

	function isTheVariantIdDisabled(variantId){
		var d = $('#productSelect option[value="' + variantId +  '"]').prop("disabled");
		return d;
	}

	function getTheVariantIdRemains(variantId){
		var d = $('#productSelect option[value="' + variantId +  '"]').data("remain");
		return d;
	}

	$(document).ready(function(){

		var variantId = getParam("variant");
		if(variantId != null){
			var variantData = $('#productSelect option[value="' + variantId + '"]').text();
			variantData = variantData.split(' / ');
			for(i=0; i<variantData.length; i++){
				$('[data-textvalue=' + variantData[i] + ']').prop('checked', true);
			}

			// カートに追加ボタンの制御
			var v = isTheVariantIdDisabled(variantId);
			$("#addToCart").prop("disabled", v);

			// 在庫の取得と設定
			v = getTheVariantIdRemains(variantId);
			console.log(v);
			$(".textRemain span").text( v);


		}

	});


  $('.selector').on("change", function () {
		var variantId = getVariantID();
		history.pushState(null,null,"?variant=" + variantId);

		// カートに追加ボタンの制御
		var v = isTheVariantIdDisabled(variantId);
		$("#addToCart").prop("disabled", v);

		// 在庫の取得と設定
		v = getTheVariantIdRemains(variantId);
		console.log(v);
		$(".textRemain span").text( v);

		// setVariantId
		$("#productSelect").val( variantId);

		var option_no = $(this).data("option_no");
		var selected = $(this).data("textvalue");
		if(option_no == 0){
			$("#productSelect option").each(function(i){
				var row = $(this).text();
				row = row.split(' / ');
				if( row[option_no] == selected){
					var available = $(this).data("available");
//				console.log(available);
					//$('[data-textvalue="' + row[1] + '"]').val($(this).val());
					$('[data-textvalue="' + row[1] + '"]').prop("disabled", !available);

				}
			});
		}

  });
	
	//予約商品チェック
	var reserveFlg = false,
		cartLeng = 0,
		alertLang1 = '予約商品は単品のみ決済可能です',
		alertLang2 = '予約商品が入ってるため、カートに追加できません。予約商品を決済してから再度購入してください';
	
	 $('#addToCart').on('click', function() {
		 var titleStr = $('.productDetail--h2').text(),
			 sameItem = false;
		 $('.CartDrawer__list > li').each(function(n) {
			var reserve = $(this).data('product-type'),
				str = $('dt', this).text();
			if(reserve === 'reserve') {
				reserveFlg = true;
			}
			if(str.indexOf(titleStr) != -1) sameItem = true;
		});
		 cartLeng = $('.CartDrawer__list > li').length;
		 if(document.URL.match("/en")) {
			 alertLang1 = 'Pre-ordered items can only be paid for individually.';
			 alertLang2 = "You can't add the item to your cart because it contains a pre-order item.Please pay for the pre-order item and then purchase again.";
		 }
		 
		 
		 if(cartLeng === 0 | sameItem) {
			 reserveFlg = false;
		 }
		 console.log(sameItem,reserveFlg)
		 if(!sameItem) {
			  if($(this).data('product-type') === 'reserve' && cartLeng > 0 ) {
				 alert(alertLang1);
				 return false;
			 }
		 }
		
		 if(reserveFlg) {
			 alert(alertLang2);
		 } else {
			 Shopify.addItemFromForm('AddToCartForm');
		 }
		  
	});
});



Shopify.onItemAdded = function(line_item) {
	$('body').addClass('js-CartDrawer-open');
	Shopify.getCart(function(cart) {
		updateCart(cart);
	});

};



Shopify.onError = function(XMLHttpRequest, textStatus) {
	// Shopify returns a description of the error in XMLHttpRequest.responseText.
	// It is JSON.
	var data = eval('(' + XMLHttpRequest.responseText + ')');
//	Shopify.updateMessage(data.description, data.message + ' (' + data.status	 + ')');
};


Shopify.onCartUpdate = function(cart) {
	updateCart(cart);
//	Shopify.updateCartInfo(cart, 'cart-info', 'shopping-cart');
};

Shopify.onProduct = function(product) {
//	console.log(product);
//	Shopify.updateProductInfo(product, 'product-info');
};








function getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
